import { Link, Stack, Typography } from "@mui/material";
import { useNavigate } from "Navigation/useNavigate";
import { appUrl } from "Utils/UrlUtils";

type Props = {
  displayName?: string | null;
  publicID: string;
  amount: string;
};

export const PaymentRequestCardDetails = ({
  displayName,
  publicID,
  amount,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Stack gap={1}>
      {displayName && (
        <Typography variant="subtitle1" fontWeight="bold">
          {displayName}
        </Typography>
      )}
      <Link
        component="button"
        variant="body2"
        color="text.secondary"
        onClick={() => navigate(`${appUrl("transaction-detail")}/${publicID}`)}
        textAlign="left"
        width="fit-content"
      >
        ID: {publicID}
      </Link>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        mt={2}
        mb={1}
      >
        {amount}
      </Typography>
    </Stack>
  );
};
